import React from 'react';
import CollapsibleContentContainer from '../../../../../common/components/CollapsibleContentContainer/CollapsibleContentContainer';

const InitialSetupInstructions = () => (
  <CollapsibleContentContainer
    orderNumber="2"
    containerName="Create your Ads in Facebook Ads Manager"
  >
    <div className="ad-details__initial-setup-instructions ad-details__section-container">
      <ul>
        <li>
          Go to &nbsp;
          <a
            href="https://www.facebook.com/adsmanager"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.facebook.com/adsmanager
          </a>
        </li>
        <li>Create a new Campaign, and choose the "Messages" objective.</li>
        <li>
          Once your Campaign, Ad Set(s), and Ad(s) are all set up, come back
          here to finish up!
        </li>
      </ul>
    </div>
  </CollapsibleContentContainer>
);

export default InitialSetupInstructions;
